/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * BarModel.tsx - Bar model hint screen
*/

import { StyleSheet, View } from 'react-native';
import Bar from './Bar';

import type { JSX } from 'react';

interface BarModelProps {
  topNumber: number,
  numBars: number
}

const BarModel = ({ topNumber, numBars }: BarModelProps): JSX.Element => {

  const topBar: JSX.Element[] = [];
  const bottomBars: JSX.Element[] = [];

  topBar.push(
    <Bar isTop number={topNumber} key="top" />
  );

  for (let i = 0; i < numBars; i++) {
    bottomBars.push(
      <Bar isTop={false} number="?" key={`bottom${i}`} />
    );
  }

  return (
    <View style={styles.barModel}>
      <View style={styles.topBar}>
        {topBar}
      </View>
      <View style={styles.bottomBar}>
        {bottomBars}
      </View>
    </View>
  );
};

export default BarModel;

const styles = StyleSheet.create({
  barModel: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    width: '90%',
    marginBottom: 20
  },

  topBar:{
    width:'100%',
    height:'50%',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    alignContent: 'flex-end',
    flexDirection: 'row'

  },

  bottomBar: {
    flexDirection: 'row',
    width: '100%',
    height: '50%',
    alignItems: 'flex-start',
    display: 'flex'
  }

});
